import { Link } from "react-router-dom";
import PageHeader from "../shared/PageHeader";

export default function TermsAndConditions() {
  return (
    <div className="container page-navbar-space">
      <PageHeader>Terms & Conditions</PageHeader>
      <div
        className="mt-4"
        style={{ maxWidth: "900px", color: "#444", lineHeight: "1.7" }}
      >
        <p className="size-16 fw-normal">
          These Terms & Conditions govern your access to and use of Ownfood
          services, including browsing, ordering, payment, and communication
          features.
        </p>
        <p className="size-16 fw-normal">
          By using Ownfood, you agree to follow applicable laws and platform
          policies. We may update these terms from time to time, and continued
          use of the platform indicates acceptance of the latest version.
        </p>
        <p className="size-16 fw-normal mb-4">
          For questions about these terms, please contact us through the
          <Link to="/contact-us" className="text-decoration-none">
            {" "}
            Contact Us{" "}
          </Link>
          page.
        </p>
      </div>
    </div>
  );
}
